'use strict';

module.exports = require('./Tooltip');


//////////////////
// WEBPACK FOOTER
// ./~/rc-tooltip/lib/index.js
// module id = ./node_modules/rc-tooltip/lib/index.js
// module chunks = 0